export function filterInvalidChildren<T>(value: T | null | false | undefined): value is T {
    return value !== null && typeof value !== 'undefined' && value !== false;
}
